module.exports = __webpack_public_path__ + "img/Dash with magnifying glass.2cbfa1dc.png";